import * as React from 'react';

import {
	FormInput,
	FormContext,
	getValueByName,
	setValueByName,
} from '../shared';

type WithFormImageUploaderProps<S, T> =  {
	value?: boolean;
	onChange?: (e: React.SyntheticEvent, value: string, files: Array<File>) => void;
} & Partial<S> & Pick<FormInput<T>, 'name'>;

function withFormImageUploader<S, T>(WrappedComponent: React.ComponentType<S>): React.ComponentClass<WithFormImageUploaderProps<S, T>> {
	return class extends React.Component<WithFormImageUploaderProps<S, T>> {
		static displayName = `withForm[HOC](${WrappedComponent.displayName || WrappedComponent.name})`;
		static contextType = FormContext;

		handleChange = (e: React.SyntheticEvent, value: string, files: Array<File>) => {
			const { getFormObject, setFormObject } = this.context;
			const { name, onChange } = this.props;
			const formObject = getFormObject();

			setValueByName(value, name, formObject);
			setFormObject(formObject);
			typeof onChange === 'function' && onChange(e, value, files);
		};

		render() {
			const { name, ...rest } = this.props;
			const { getFormObject } = this.context;
			const formObject = getFormObject();
			const value = getValueByName(name, formObject);

			return (
				<WrappedComponent
					{...rest as any}
					value={value}
					onChange={this.handleChange}
				/>
			);
		}
	}
}

export default withFormImageUploader;
